function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect, useRef } from 'react';
import { MapContainer, TileLayer } from '@manifesto-tech/react-leaflet';
import 'projektpro-leaflet-smoothwheelzoom';
import MapBoundary from './MapBoundary.jsx';
import Markers from './Markers.jsx';
import Sidebar from './Sidebar.jsx';
import Search from './Search.jsx';
import { getFeatures } from '../utils/utilities';
export default function LeafletMap(_ref) {
  var mapId = _ref.mapId,
    baseApiUrl = _ref.baseApiUrl,
    blockHeading = _ref.blockHeading;
  var mapWrapper = useRef(null);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    map = _useState2[0],
    setMap = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    locationData = _useState4[0],
    setLocationData = _useState4[1];
  var _useState5 = useState({
      printable_map_url: ''
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    locationProperties = _useState6[0],
    setLocationProperties = _useState6[1];
  var _useState7 = useState({}),
    _useState8 = _slicedToArray(_useState7, 2),
    markerData = _useState8[0],
    setMarkerData = _useState8[1];
  var _useState9 = useState({}),
    _useState10 = _slicedToArray(_useState9, 2),
    markers = _useState10[0],
    setMarkers = _useState10[1];
  var _useState11 = useState({}),
    _useState12 = _slicedToArray(_useState11, 2),
    visibleMarkers = _useState12[0],
    setVisibleMarkers = _useState12[1];
  var _useState13 = useState(markers),
    _useState14 = _slicedToArray(_useState13, 2),
    sidebarMarkers = _useState14[0],
    setSidebarMarkers = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedMarkerButton = _useState16[0],
    setSelectedMarkerButton = _useState16[1];
  var _useState17 = useState(''),
    _useState18 = _slicedToArray(_useState17, 2),
    searchInput = _useState18[0],
    setSearchInput = _useState18[1];
  var _useState19 = useState(''),
    _useState20 = _slicedToArray(_useState19, 2),
    activeMarkerGroup = _useState20[0],
    setActiveMarkerGroup = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    mapIsVisible = _useState22[0],
    setIsVisible = _useState22[1];
  var popupClickHandler = function popupClickHandler(popup, e) {
    var _popup$_source;
    var clickedMarker = (popup === null || popup === void 0 ? void 0 : (_popup$_source = popup._source) === null || _popup$_source === void 0 ? void 0 : _popup$_source._icon) || false;
    if (clickedMarker !== e.target && !popup._container.contains(e.target)) {
      popup.close();
    }
  };
  useEffect(function () {
    if (mapId) {
      fetch("".concat(baseApiUrl, "/api/maps/locations/").concat(mapId)).then(function (response) {
        return response.json();
      }).then(function (data) {
        var locations = typeof data === 'string' || data instanceof String ? JSON.parse(data) : data;
        setLocationData(locations);
      });
      fetch("".concat(baseApiUrl, "/api/maps/markers/").concat(mapId, "/all")).then(function (response) {
        return response.json();
      }).then(function (data) {
        var features = typeof data === 'string' || data instanceof String ? JSON.parse(data) : data;
        setMarkerData(features);
      });
    }
  }, []);
  useEffect(function () {
    if (Object.keys(markerData).length > 0) {
      var features = getFeatures(markerData);
      setMarkers(features);
      setVisibleMarkers(features);
      setSidebarMarkers(features);
    }
  }, [markerData]);
  useEffect(function () {
    if (Object.keys(locationData).length) {
      if (locationData.features.length) {
        var properties = locationData.features[0].properties;
        setLocationProperties(properties);
      }
    }
  }, [locationData]);
  useEffect(function () {
    if (activeMarkerGroup === '') {
      setSelectedMarkerButton(false);
    }
  }, [activeMarkerGroup]);
  useEffect(function () {
    var observer = new IntersectionObserver(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
        entry = _ref3[0];
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    });
    if (map) {
      var mapContainer = map.getContainer();
      map.SmoothWheelZoom = true;
      if (mapContainer) {
        observer.observe(mapContainer);
      }
      var popupClickListener = popupClickHandler;
      map.on('popupopen', function (_ref4) {
        var popup = _ref4.popup;
        popupClickListener = popupClickHandler.bind([], popup);
        mapWrapper.current.classList.add(['leaflet-popup-open']);
        document.addEventListener('click', popupClickListener);
      });
      map.on('popupclose', function () {
        mapWrapper.current.classList.remove(['leaflet-popup-open']);
        document.removeEventListener('click', popupClickListener);
      });
    }
    return function () {
      observer.disconnect();
    };
  }, [map]);
  useEffect(function () {
    if (mapIsVisible) {
      map.invalidateSize();
    }
  }, [mapIsVisible]);
  return /*#__PURE__*/React.createElement("div", {
    className: "o-map__wrapper",
    ref: mapWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-sandstone dark:bg-darkstone dark:text-sandstone"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container flex max-md:flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-end md:w-2/3 mb-11 md:mr-5 lg:mr-9"
  }, blockHeading && /*#__PURE__*/React.createElement("h2", null, blockHeading)), /*#__PURE__*/React.createElement(Search, {
    className: ['md:w-1/3', 'flex-grow', 'p-6', 'bg-gold', blockHeading && 'md:mt-16 lg:mt-24'].join(' '),
    markers: markers,
    visibleMarkers: visibleMarkers,
    setVisibleMarkers: setVisibleMarkers,
    sidebarMarkers: sidebarMarkers,
    setSidebarMarkers: setSidebarMarkers,
    selectedMarkerButton: selectedMarkerButton,
    setSelectedMarkerButton: setSelectedMarkerButton,
    searchInput: searchInput,
    setSearchInput: setSearchInput,
    setActiveMarkerGroup: setActiveMarkerGroup
  }))), /*#__PURE__*/React.createElement("div", {
    className: "bg-white dark:bg-darkstone py-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container flex max-md:flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full md:w-2/3 md:mr-5 lg:mr-9"
  }, /*#__PURE__*/React.createElement(MapContainer, {
    className: "w-full max-md:aspect-[1/1] md:min-h-lg lg:min-h-2xl flex-grow",
    ref: setMap,
    center: [51.505, -0.09],
    zoom: 14,
    zoomSnap: 0,
    scrollWheelZoom: false
  }, /*#__PURE__*/React.createElement(TileLayer, {
    attribution: "\xA9 <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a>",
    url: "https://tile.openstreetmap.org/{z}/{x}/{y}.png"
  }), /*#__PURE__*/React.createElement(React.Fragment, null, Object.keys(locationData).length && /*#__PURE__*/React.createElement(MapBoundary, {
    locationData: locationData
  }), Object.keys(visibleMarkers).length && /*#__PURE__*/React.createElement(Markers, {
    markers: visibleMarkers
  }))), locationProperties.printable_map_url && /*#__PURE__*/React.createElement("a", {
    className: "text-black dark:text-sandstone text-sm font-normal underline mt-1 underline-offset-4",
    href: locationProperties.printable_map_url,
    target: "_blank",
    rel: "noreferrer"
  }, "Download a printable map")), map && /*#__PURE__*/React.createElement(Sidebar, {
    className: "o-map__sidebar md:w-1/3 flex-grow max-md:mt-4 md:max-h-xl lg:max-h-3xl overflow-y-scroll",
    map: map,
    visibleMarkers: visibleMarkers,
    setVisibleMarkers: setVisibleMarkers,
    sidebarMarkers: sidebarMarkers,
    selectedMarkerButton: selectedMarkerButton,
    setSelectedMarkerButton: setSelectedMarkerButton,
    searchInput: searchInput,
    activeMarkerGroup: activeMarkerGroup,
    setActiveMarkerGroup: setActiveMarkerGroup
  }))));
}